<template>
  <span :class="spanClass">{{ title }}</span>
</template>

<script>
export default {
  name: 'StatusTitle',
  props: {
    status: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: false,
      validator: value => {
        return ['course', 'session', 'user', 'device'].indexOf(value) !== -1
      }
    },
    statusList: {
      type: Object,
      required: false
    },
    isBadge: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    list() {
      if (this.statusList) {
        return this.statusList
      }
      let list = {}
      if (this.type === 'course') {
        list = require('@/modules/status-list.js').courseStatusList
      } else if (this.type === 'session') {
        list = require('@/modules/status-list.js').sessionStatusList
      } else if (this.type === 'user') {
        list = require('@/modules/status-list.js').userStatusList
      } else if (this.type === 'device') {
        list = require('@/modules/status-list.js').deviceStatusList
      }
      return list
    },
    title() {
      if (!this.list[this.status]) {
        return ''
      }
      return this.list[this.status].title
    },
    color() {
      if (!this.list[this.status] || !this.list[this.status].color) {
        return 'dark'
      }
      return this.list[this.status].color
    },
    spanClass() {
      return this.isBadge ? `badge badge-pill badge-white text-${this.color}` : `text-${this.color}`
    }
  }
}
</script>
